import { ActionType, createReducer } from "typesafe-actions";
import * as actions from "store/features/general/general.actions";
import { fetchSchema } from "store/features/forms/forms.actions";
import { FormSchema } from "api/factories/form.factory";

export type FormsAction = ActionType<typeof actions>;

export type FormsState = Readonly<{
    isProcessing: boolean;
    hasError: boolean;
    schema: FormSchema[] | null;
}>;

export const formsSchema: FormsState = {
    isProcessing: false,
    hasError: false,
    schema: null,
};

export const formsReducer = createReducer<FormsState, FormsAction>(formsSchema)
    .handleAction(fetchSchema.request, (state) => {
        return {
            ...state,
            isProcessing: true,
        };
    })
    .handleAction(fetchSchema.success, (state, { payload: { schema } }) => {
        return {
            ...state,
            isProcessing: false,
            schema,
        };
    });
